import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";

import { ModalController } from "@ionic/angular";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ReverseWaitListResponce } from "src/app/model/ReverseWaitListResponce";
import { MatSort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { SchemeEditorService } from "src/app/services/scheme-editor.service";
import { SchemeEditorResponse } from "src/app/model/SchemeEditorResponse";
import { SchemeEditorModalComponent } from "./scheme-editor-modal/scheme-editor-modal.component";

@Component({
  selector: "app-secure-scheme-editor",
  templateUrl: "./scheme-editor.component.html",
  styleUrls: ["./scheme-editor.component.scss"],
})
export class SchemeEditorComponent implements OnInit {
  
  isLoading = false;
  isProgressBarLoading: Boolean = false;
  pageSizeOptions: number[] = [10, 25, 100];
  pageSize = 10;
  currentPage = 0;
  lotteries: { [key: number]: string };
  dataSource: MatTableDataSource<SchemeEditorResponse> = new MatTableDataSource();
  page: Page<SchemeEditorResponse>;
  isSearchDisabled: boolean = false;
  schemes: { [key: number]: string };
  selectedLottery: number;
  selectedScheme: number;
  isSubmitDisabled: boolean = false;
  lotteryKey: { key: number; value: string };
  schemeKey: { key: number; value: string };
  base64: string | ArrayBuffer;

  maskMobileNumber: string;
  schemeId: number;

  filterFormGroup: FormGroup = new FormGroup({});

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "No",
    "lottery",
    "schemeCode",
    "schemeName",
    "isActive",
    "action",
  ];

  constructor(
    private schemeEditorService: SchemeEditorService,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit(): void {

    this.filterFormGroup = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
      lotteryFilter: new FormControl(null, [
        Validators.required
      ]),
    });

    this.schemeEditorService.initPage().subscribe((data: any) => {

      console.log(data);

      this.isLoading = false;
      if (data.status === "SUCCESS") {
        this.lotteries = data.lotteryList;
      }
      else {
        this.schemeEditorService.errorToast(data.errorMessage);
      }
    }, (error) => {
      this.isLoading = false;
      this.schemeEditorService.errorToast(error?.error?.errorMessage || error?.error?.message);
    }
    );
    
  }

  onLotteryChange(e: any){
    this.selectedLottery = e.key;
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.isProgressBarLoading = true;
    this.schemeEditorService.initLotteryEventForSchemeEditor(this.currentPage, 
      this.pageSize, this.selectedLottery, this.filterFormGroup.value.filterText).subscribe((data)=>{
        console.log(data)
        if(data.status === "SUCCESS"){
          this.page = data.page;
          this.dataSource = new MatTableDataSource(this.page.content);

          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = this.page.totalElements;
          });

        } else {
          this.schemeEditorService.errorToast(data.errorMessage);
        }

        this.isLoading = false;
        this.isProgressBarLoading = false;
      }, 
      (error)=>{
        this.isLoading = false;
        this.isProgressBarLoading = false;
        this.schemeEditorService.errorToast(error?.error?.errorMessage || error?.error?.message);
    });

    this.isLoading = false;
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  onSearch() {
    this.isProgressBarLoading = true;

    if (!this.selectedLottery) {
      this.isLoading = false;
      this.isSearchDisabled = false;
      return this.schemeEditorService.errorToast(
        "Please Select Lottery from the filter."
      );
    }
   
    if(this.filterFormGroup.value.filterText == null){
      return this.schemeEditorService.errorToast(
        "Please Enter Scheme code/name"
      );
    }

    if (this.filterFormGroup.valid) {
      this.loadData();
    }
  }

  deactivate(key: number) {
    // if (confirm("Do you want to De-Activate the Scheme")) {
      this.schemeEditorService
        .toggleActivationScheme(key, "N")
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            let selectedObj = this.page.content.find((o) => o.key === key);
            selectedObj.isActive = "N";
            this.schemeEditorService.successToast("Scheme has been deactivated successfully.");
          } else {
            this.schemeEditorService.errorToast(data.errorMessage);
          }
        });
    // }
  }

  upload(key: number) {
    this.isLoading =false;
    this.schemeId = key;
    if (confirm("Do you want to De-Activate the Scheme")) {
      this.openModal();
    }
    // this.schemeEditorService
    //     .sendOtp(key)
    //     .subscribe((data: any) => {
    //       console.log(data);
    //       if (data.status === "SUCCESS") {
            
    //         this.maskMobileNumber = data.maskMobileNumber; 
    //         this.openModal();
    //       } else {
    //         return this.schemeEditorService.errorToast(data.errorMessage);
    //       }
    //     });

    
  }

  async openModal(){
    const modal = await this.modalCtrl.create({
      component: SchemeEditorModalComponent,
      componentProps: {
        modalHeader: "Scheme Editor Details",
        maskMobileNumber : this.maskMobileNumber,
        key : this.schemeId,
        // isOtpVerify : true
      }
    });
    modal.present();
  
    const { data, role } = await modal.onWillDismiss();
    
    if (data != null && role === "submit") {
      console.log(data);
      // this.deactivate(this.schemeId);
    }
  }

  activate(key: number) {
    if (confirm("Do you want to Activate the Scheme")) {
      this.schemeEditorService
        .toggleActivationScheme(key, "Y")
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            let selectedObj = this.page.content.find((o) => o.key === key);
            selectedObj.isActive = "Y";
          } else {
            this.schemeEditorService.errorToast(data.errorMessage);
          }
        });
    }
  }

  resetFilter(){
    // this.filterFormGroup.controls["filterText"].setValue(null);
    // this.loadData();
    // this.ngOnInit();
    window.location.reload();
  }

}
